'use client';

import { TableColumnNumberText, tableColumnNumberTextTag } from '@ni/nimble-components/dist/esm/table-column/number-text';
import { wrap } from '../../utilities/react-wrapper';

export { tableColumnNumberTextTag };
export { type TableColumnNumberText };
export const NimbleTableColumnNumberText = wrap(TableColumnNumberText);
